// @ts-nocheck
/**
 * New Nexode Pro — 留邮 / 规则弹窗 / 文案过渡 / 核心卖点 / 产品 Quick Add
 */
(function () {
  'use strict';

  const TAG_NAME = 'new-nexode-pro-section';
  const FORM_SUBMIT_URL = 'https://ecf.cirkleinc.com/api/form-submit';
  const MOBILE_MQ = '(max-width: 1023.98px)';

  function validateEmailFormat(email) {
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      String(email).toLowerCase()
    );
  }

  function bindEmailBlock(block) {
    if (!(block instanceof HTMLElement)) return;
    if (block.dataset.nnpEmailInited === '1') return;
    block.dataset.nnpEmailInited = '1';

    const submitBtn = block.querySelector('.ug-new-nexode-pro__email-submit');
    const input = block.querySelector('.ug-new-nexode-pro__email-input');
    const privacyCheckbox = block.querySelector('.ug-new-nexode-pro__email-checkbox');
    const errorMsg = block.querySelector('.ug-new-nexode-pro__email-error');
    const successMsg = block.querySelector('.ug-new-nexode-pro__email-message');

    const formId = block.getAttribute('data-form-id') || '';
    const successText = block.getAttribute('data-success-text') || 'Thanks for subscribing!';
    const failText = block.getAttribute('data-fail-text') || 'Subscription failed, please try again later.';
    const privacyError = block.getAttribute('data-privacy-error') || 'Please agree to the privacy policy.';
    const emailError = block.getAttribute('data-email-error') || 'Please enter a valid email address.';

    if (!(submitBtn instanceof HTMLButtonElement) || !(input instanceof HTMLInputElement)) {
      delete block.dataset.nnpEmailInited;
      return;
    }

    const showError = (msg) => {
      if (errorMsg instanceof HTMLElement) {
        errorMsg.textContent = msg;
        errorMsg.style.display = 'block';
      }
      if (successMsg instanceof HTMLElement) {
        successMsg.style.display = 'none';
      }
    };

    const showSuccess = (msg) => {
      if (successMsg instanceof HTMLElement) {
        successMsg.textContent = msg;
        successMsg.style.display = 'block';
      }
      if (errorMsg instanceof HTMLElement) {
        errorMsg.style.display = 'none';
      }
    };

    const trackSubscription = (isSuccess) => {
      const w = window;
      if (!w.ugGa4Track || typeof w.ugGa4Track.subscriptionEvent !== 'function') return;
      try {
        w.ugGa4Track.subscriptionEvent({ isSuccess, position: 'new-nexode-pro' });
      } catch (_) {}
    };

    const onSubmit = async () => {
      const emailVal = input.value.trim();

      if (!validateEmailFormat(emailVal)) {
        showError(emailError);
        return;
      }

      if (privacyCheckbox instanceof HTMLInputElement && !privacyCheckbox.checked) {
        showError(privacyError);
        return;
      }

      if (!formId) {
        showError(failText);
        return;
      }

      if (errorMsg instanceof HTMLElement) errorMsg.style.display = 'none';
      if (successMsg instanceof HTMLElement) successMsg.style.display = 'none';
      if (submitBtn.classList.contains('loading')) return;

      submitBtn.classList.add('loading');

      try {
        const response = await fetch(FORM_SUBMIT_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: emailVal,
            accepts_marketing:
              privacyCheckbox instanceof HTMLInputElement && privacyCheckbox.checked ? 'on' : 'off',
            form_id: formId
          })
        });

        let data = null;
        try {
          data = await response.json();
        } catch (_) {
          showError(failText);
          trackSubscription(false);
          return;
        }

        const isSuccess = data && data.status === 'success';
        if (isSuccess) {
          input.value = '';
          showSuccess(successText);
        } else {
          const serverMsg =
            (data && data.errors && data.errors.email && data.errors.email[0]) ||
            (data && data.message) ||
            failText;
          showError(serverMsg);
        }
        trackSubscription(!!isSuccess);
      } catch (_) {
        showError(failText);
        trackSubscription(false);
      } finally {
        submitBtn.classList.remove('loading');
      }
    };

    const onKeydown = (e) => {
      if (e instanceof KeyboardEvent && e.key === 'Enter') {
        e.preventDefault();
        submitBtn.click();
      }
    };

    submitBtn.addEventListener('click', onSubmit);
    input.addEventListener('keydown', onKeydown);

    block._nnpEmailCleanup = () => {
      submitBtn.removeEventListener('click', onSubmit);
      input.removeEventListener('keydown', onKeydown);
      delete block._nnpEmailCleanup;
      delete block.dataset.nnpEmailInited;
    };
  }

  /** 规则弹窗 */
  function bindTermsModal(termsSection) {
    if (!(termsSection instanceof HTMLElement)) return;
    if (termsSection.dataset.nnpTermsInited === '1') return;
    termsSection.dataset.nnpTermsInited = '1';

    const openBtn = termsSection.querySelector('[data-nnp-terms-open]');
    const modal = termsSection.querySelector('[data-nnp-terms-modal]');
    if (!(openBtn instanceof HTMLButtonElement) || !(modal instanceof HTMLElement)) {
      delete termsSection.dataset.nnpTermsInited;
      return;
    }

    const closeEls = modal.querySelectorAll('[data-nnp-terms-close]');
    const focusableSelector =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

    let lastFocus = null;

    const getFocusable = () =>
      Array.from(modal.querySelectorAll(focusableSelector)).filter(
        (el) =>
          el instanceof HTMLElement &&
          !el.hasAttribute('disabled') &&
          el.getAttribute('aria-hidden') !== 'true'
      );

    const open = () => {
      lastFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      modal.hidden = false;
      document.documentElement.classList.add('ug-nnp-terms-open');
      openBtn.setAttribute('aria-expanded', 'true');
      const first = getFocusable()[0];
      if (first instanceof HTMLElement) {
        window.requestAnimationFrame(() => first.focus());
      }
    };

    const close = () => {
      modal.hidden = true;
      document.documentElement.classList.remove('ug-nnp-terms-open');
      openBtn.setAttribute('aria-expanded', 'false');
      if (lastFocus && document.contains(lastFocus)) {
        lastFocus.focus();
      } else {
        openBtn.focus();
      }
      lastFocus = null;
    };

    const onDocKeydown = (e) => {
      if (!(e instanceof KeyboardEvent) || modal.hidden) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
        return;
      }
      if (e.key !== 'Tab') return;
      const focusable = getFocusable();
      if (focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const active = document.activeElement;
      if (e.shiftKey) {
        if (active === first || !modal.contains(active)) {
          e.preventDefault();
          last.focus();
        }
      } else if (active === last || !modal.contains(active)) {
        e.preventDefault();
        first.focus();
      }
    };

    openBtn.addEventListener('click', open);
    closeEls.forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', onDocKeydown, true);

    termsSection._nnpTermsCleanup = () => {
      openBtn.removeEventListener('click', open);
      closeEls.forEach((el) => el.removeEventListener('click', close));
      document.removeEventListener('keydown', onDocKeydown, true);
      if (!modal.hidden) {
        modal.hidden = true;
        document.documentElement.classList.remove('ug-nnp-terms-open');
        openBtn.setAttribute('aria-expanded', 'false');
      }
      delete termsSection.dataset.nnpTermsInited;
    };
  }

  /** GSAP / ScrollTrigger 就绪；返回取消函数（section 卸载时调用） */
  function whenGsapReady(onReady, onFail) {
    let cancelled = false;
    let timer = 0;

    const cancel = () => {
      cancelled = true;
      if (timer) {
        window.clearInterval(timer);
        timer = 0;
      }
    };

    const attempt = () => {
      if (cancelled) return true;
      const gsap = window.gsap;
      const ScrollTrigger = window.ScrollTrigger;
      if (gsap && ScrollTrigger) {
        gsap.registerPlugin(ScrollTrigger);
        onReady(gsap, ScrollTrigger);
        return true;
      }
      return false;
    };

    if (attempt()) return cancel;

    let tries = 0;
    timer = window.setInterval(() => {
      if (cancelled) {
        window.clearInterval(timer);
        timer = 0;
        return;
      }
      tries += 1;
      if (attempt()) {
        window.clearInterval(timer);
        timer = 0;
      } else if (tries >= 80) {
        window.clearInterval(timer);
        timer = 0;
        if (!cancelled && typeof onFail === 'function') onFail();
      }
    }, 50);

    return cancel;
  }

  function getScrollPos(section, ScrollTrigger, position) {
    const probe = ScrollTrigger.create({ trigger: section, start: position, end: position });
    const y = probe.start;
    probe.kill();
    return y;
  }

  /** 核心卖点 — 滚动入场 */
  function getProductIntroY(product) {
    if (!(product instanceof HTMLElement)) return 0;
    const stage = product.closest('.ug-new-nexode-pro__highlights-stage');
    const stageH = stage instanceof HTMLElement ? stage.offsetHeight : 0;
    const isMobile = window.matchMedia(MOBILE_MQ).matches;
    // introY：MO stageH*0.14-20 / PC stageH*0.22-120
    if (isMobile) {
      return stageH * 0.14 - 20;
    }
    return stageH * 0.22 - 120;
  }

  
  function getPcCardIntroX(card) {
    if (!(card instanceof HTMLElement)) return 0;
    if (
      card.classList.contains('ug-new-nexode-pro__highlights-card--single-port') ||
      card.classList.contains('ug-new-nexode-pro__highlights-card--total-power')
    ) {
      return -100;
    }
    return 100;
  }

  function setLinePathsForAnimation(gsap, paths) {
    paths.forEach((path) => {
      const len = path.getTotalLength();
      gsap.set(path, { strokeDasharray: len, strokeDashoffset: len });
    });
  }

  function setupHighlightsScroll(section, gsap, ScrollTrigger, textST) {
    const product = section.querySelector('[data-nnp-highlight-product]');
    const bg = section.querySelector('.ug-new-nexode-pro__highlights-bg');
    const title = section.querySelector('.ug-new-nexode-pro__highlights-title');
    const lines = section.querySelector('.ug-new-nexode-pro__highlights-lines');
    const hotspotsPc = section.querySelector('.ug-new-nexode-pro__highlights-hotspots-pc');
    const hotspotsMo = section.querySelector('.ug-new-nexode-pro__highlights-hotspots-mo');
    const pcCards = section.querySelectorAll(
      '.ug-new-nexode-pro__highlights-pc-cards .ug-new-nexode-pro__highlights-card'
    );
    const moPanel = section.querySelector('.ug-new-nexode-pro__highlights-mo-panel');
    const isMobile = window.matchMedia(MOBILE_MQ).matches;
    const linePaths = lines ? Array.from(lines.querySelectorAll('path')) : [];
    const pcHotspots = hotspotsPc
      ? Array.from(hotspotsPc.querySelectorAll('.ug-new-nexode-pro__highlights-hotspot'))
      : [];
    const moHotspots = hotspotsMo
      ? Array.from(hotspotsMo.querySelectorAll('.ug-new-nexode-pro__highlights-hotspot'))
      : [];
    section.classList.add('is-gsap-ready');

    const introY = getProductIntroY(product);

    if (product instanceof HTMLElement) {
      gsap.set(product, {
        xPercent: -50,
        y: introY,
        scale: 1.8,
        rotation: 5,
        transformOrigin: '50% 50%',
        force3D: true
      });
    }
    if (bg instanceof HTMLElement) gsap.set(bg, { opacity: 0 });
    if (title instanceof HTMLElement) gsap.set(title, { opacity: 0 });
    if (lines instanceof HTMLElement) gsap.set(lines, { opacity: 0 });
    setLinePathsForAnimation(gsap, linePaths);
    pcCards.forEach((card) => gsap.set(card, { opacity: 0, x: getPcCardIntroX(card) }));
    if (isMobile) {
      moHotspots.forEach((hotspot) => gsap.set(hotspot, { opacity: 0 }));
      if (moPanel instanceof HTMLElement) {
        gsap.set(moPanel, { opacity: 0 });
      }
    } else {
      pcHotspots.forEach((hotspot) =>
        gsap.set(hotspot, { xPercent: -50, yPercent: -50, scale: 0, transformOrigin: '50% 50%' })
      );
    }

    const setRevealed = (revealed) => {
      section.classList.toggle('is-revealed', revealed);
    };
    const getStart = () => {
      const enter = getScrollPos(section, ScrollTrigger, 'top bottom');
      const root = section.closest('new-nexode-pro-section');
      const textSection = root ? root.querySelector('[data-nnp-text-reveal]') : null;
      const liveST =
        (textSection && textSection._nnpTextGradientScrollTrigger) || textST;
      const textEnd = liveST && typeof liveST.end === 'number' ? liveST.end : enter;
      return Math.max(textEnd, enter);
    };
    const getEnd = () => getScrollPos(section, ScrollTrigger, 'center center');

    let startOpt = getStart;
    if (getStart() >= getEnd()) {
      startOpt = () => getScrollPos(section, ScrollTrigger, 'top bottom');
    }

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: startOpt,
        end: 'center center',
        scrub: 0.3,
        invalidateOnRefresh: true,
        fastScrollEnd: true,
        onUpdate: (self) => setRevealed(self.progress >= 0.999)
      },
      defaults: { ease: 'none' }
    });

    if (product instanceof HTMLElement) {
      tl.to(product, { y: 0, scale: 1, rotation: 0, duration: 0.5 }, 0);
    }
    if (bg instanceof HTMLElement) {
      tl.to(bg, { opacity: 1, duration: 0.14 }, 0.52);
    }
    if (title instanceof HTMLElement) {
      tl.to(title, { opacity: 1, duration: 0.14 }, 0.68);
    }
    if (!isMobile && lines instanceof HTMLElement) {
      tl.to(lines, { opacity: 1, duration: 0.14 }, 0.84);
    }
    if (!isMobile && pcCards.length) {
      tl.to(pcCards, { opacity: 1, x: 0, duration: 0.16, stagger: 0.04 }, 0.84);
    }
    if (!isMobile && linePaths.length) {
      tl.to(linePaths, { strokeDashoffset: 0, duration: 0.2, stagger: 0.05 }, 0.88);
    }
    if (!isMobile && pcHotspots.length) {
      tl.to(pcHotspots, { scale: 1, duration: 0.14, stagger: 0.05 }, 0.9);
    }
    if (isMobile && moHotspots.length) {
      tl.to(moHotspots, { opacity: 1, duration: 0.14, stagger: 0.05 }, 0.88);
    }
    if (isMobile && moPanel instanceof HTMLElement) {
      tl.to(moPanel, { opacity: 1, duration: 0.14 }, 0.96);
    }

    const scrollTrigger = tl.scrollTrigger;
    section._nnpHighlightsScrollTrigger = scrollTrigger;

    let lastIsMobile = isMobile;
    let resizeTimer = 0;
    let rebuilding = false;

    const softRefresh = () => {
      if (product instanceof HTMLElement && scrollTrigger.progress < 0.01) {
        gsap.set(product, { y: getProductIntroY(product) });
      }
      scrollTrigger.refresh();
    };

    const rebuildForBreakpoint = () => {
      if (rebuilding) return;
      rebuilding = true;
      window.removeEventListener('resize', debouncedResize);
      window.clearTimeout(resizeTimer);
      if (scrollTrigger) scrollTrigger.kill();
      tl.kill();
      section.classList.remove('is-gsap-ready', 'is-revealed');
      if (product instanceof HTMLElement) gsap.set(product, { clearProps: 'transform' });
      if (bg instanceof HTMLElement) gsap.set(bg, { clearProps: 'opacity' });
      if (title instanceof HTMLElement) gsap.set(title, { clearProps: 'opacity' });
      if (lines instanceof HTMLElement) gsap.set(lines, { clearProps: 'opacity' });
      if (linePaths.length) gsap.set(linePaths, { clearProps: 'strokeDashoffset,strokeDasharray' });
      if (pcCards.length) gsap.set(pcCards, { clearProps: 'opacity,transform' });
      if (pcHotspots.length) gsap.set(pcHotspots, { clearProps: 'transform' });
      if (moHotspots.length) gsap.set(moHotspots, { clearProps: 'opacity' });
      if (moPanel instanceof HTMLElement) gsap.set(moPanel, { clearProps: 'opacity' });
      delete section._nnpHighlightsScrollTrigger;
      setupHighlightsScroll(section, gsap, ScrollTrigger, textST);
      ScrollTrigger.refresh();
    };

    const onResize = () => {
      const nextIsMobile = window.matchMedia(MOBILE_MQ).matches;
      if (nextIsMobile !== lastIsMobile) {
        lastIsMobile = nextIsMobile;
        rebuildForBreakpoint();
        return;
      }
      softRefresh();
    };

    const debouncedResize = () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(onResize, 150);
    };
    window.addEventListener('resize', debouncedResize);
    window.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
    window.requestAnimationFrame(() => ScrollTrigger.refresh());

    section._nnpHighlightsScrollCleanup = () => {
      window.removeEventListener('resize', debouncedResize);
      window.clearTimeout(resizeTimer);
      if (scrollTrigger) scrollTrigger.kill();
      tl.kill();
      section.classList.remove('is-gsap-ready', 'is-revealed');
      if (product instanceof HTMLElement) gsap.set(product, { clearProps: 'transform' });
      if (bg instanceof HTMLElement) gsap.set(bg, { clearProps: 'opacity' });
      if (title instanceof HTMLElement) gsap.set(title, { clearProps: 'opacity' });
      if (lines instanceof HTMLElement) gsap.set(lines, { clearProps: 'opacity' });
      if (linePaths.length) gsap.set(linePaths, { clearProps: 'strokeDashoffset,strokeDasharray' });
      if (pcCards.length) gsap.set(pcCards, { clearProps: 'opacity,transform' });
      if (pcHotspots.length) gsap.set(pcHotspots, { clearProps: 'transform' });
      if (moHotspots.length) gsap.set(moHotspots, { clearProps: 'opacity' });
      if (moPanel instanceof HTMLElement) gsap.set(moPanel, { clearProps: 'opacity' });
      delete section.dataset.nnpHighlightsScrollInited;
      delete section._nnpHighlightsScrollTrigger;
    };
  }

  function bindHighlightsScroll(section) {
    if (!(section instanceof HTMLElement)) return;
    if (section.dataset.nnpHighlightsScrollInited === '1') return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      section.dataset.nnpHighlightsScrollInited = '1';
      section.classList.add('is-revealed');
      return;
    }

    let aborted = false;
    const cancelWait = whenGsapReady(
      (gsap, ScrollTrigger) => {
        if (aborted || !section.isConnected) return;
        const root = section.closest('new-nexode-pro-section');
        const textSection = root ? root.querySelector('[data-nnp-text-reveal]') : null;

        const run = () => {
          if (aborted || !section.isConnected) return;
          if (section.dataset.nnpHighlightsScrollInited === '1') return;
          section.dataset.nnpHighlightsScrollInited = '1';

          const textST = textSection && textSection._nnpTextGradientScrollTrigger;
          setupHighlightsScroll(section, gsap, ScrollTrigger, textST);
          ScrollTrigger.refresh();
        };

        let waitFrames = 0;
        const waitForText = () => {
          if (aborted || !section.isConnected) return;
          if (!textSection) {
            run();
            return;
          }
          const textReady =
            textSection._nnpTextGradientScrollTrigger ||
            (textSection.dataset.nnpTextGradientInited === '1' &&
              textSection.dataset.nnpTextGradientNoScroll === '1');
          if (textReady || waitFrames > 180) {
            run();
            return;
          }
          waitFrames += 1;
          window.requestAnimationFrame(waitForText);
        };

        waitForText();
      },
      () => {
        if (aborted || !section.isConnected) return;
        section.dataset.nnpHighlightsScrollInited = '1';
        section.classList.add('is-revealed');
      }
    );

    section._nnpGsapWaitCancel = () => {
      aborted = true;
      if (typeof cancelWait === 'function') cancelWait();
      delete section._nnpGsapWaitCancel;
    };
  }

  /** 核心卖点 — MO 轮播 */
  function bindHighlightsCarousel(section) {
    if (!(section instanceof HTMLElement)) return;
    if (section.dataset.nnpHighlightsCarouselInited === '1') return;
    section.dataset.nnpHighlightsCarouselInited = '1';

    const slides = Array.from(section.querySelectorAll('[data-nnp-highlight-slide]'));
    const moHotspotsRoot = section.querySelector('.ug-new-nexode-pro__highlights-hotspots-mo');
    const hotspots = moHotspotsRoot
      ? Array.from(moHotspotsRoot.querySelectorAll('[data-nnp-highlight-go]'))
      : [];
    const prevBtn = section.querySelector('[data-nnp-highlight-prev]');
    const nextBtn = section.querySelector('[data-nnp-highlight-next]');
    const progress = section.querySelector('[data-nnp-highlight-progress]');
    const progressFill = section.querySelector('[data-nnp-highlight-progress-fill]');

    if (!slides.length) return;

    let index = 1;
    const cleanups = [];

    const canInteract = () => section.classList.contains('is-revealed');

    const render = () => {
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.hidden = !active;
      });

      hotspots.forEach((hotspot, i) => {
        hotspot.classList.toggle('is-active', i === index);
      });

      if (progress instanceof HTMLElement) {
        progress.setAttribute('aria-valuenow', String(index + 1));
        progress.setAttribute('aria-valuemax', String(slides.length));
      }

      if (progressFill instanceof HTMLElement) {
        const pct = ((index + 1) / slides.length) * 100;
        progressFill.style.width = pct + '%';
      }

      if (prevBtn instanceof HTMLButtonElement) {
        prevBtn.disabled = index <= 0;
      }

      if (nextBtn instanceof HTMLButtonElement) {
        nextBtn.disabled = index >= slides.length - 1;
      }
    };

    const goTo = (nextIndex) => {
      if (!canInteract()) return;
      const total = slides.length;
      index = ((nextIndex % total) + total) % total;
      render();
    };

    hotspots.forEach((hotspot) => {
      const handler = () => {
        const raw = hotspot.getAttribute('data-nnp-highlight-go');
        const target = raw !== null ? Number(raw) : NaN;
        if (!Number.isNaN(target)) goTo(target);
      };
      hotspot.addEventListener('click', handler);
      cleanups.push(() => hotspot.removeEventListener('click', handler));
    });

    if (prevBtn instanceof HTMLButtonElement) {
      const handler = () => goTo(index - 1);
      prevBtn.addEventListener('click', handler);
      cleanups.push(() => prevBtn.removeEventListener('click', handler));
    }

    if (nextBtn instanceof HTMLButtonElement) {
      const handler = () => goTo(index + 1);
      nextBtn.addEventListener('click', handler);
      cleanups.push(() => nextBtn.removeEventListener('click', handler));
    }

    render();

    section._nnpHighlightsCarouselCleanup = () => {
      cleanups.forEach((fn) => {
        try {
          fn();
        } catch (_) {}
      });
      delete section._nnpHighlightsCarouselCleanup;
      delete section.dataset.nnpHighlightsCarouselInited;
    };
  }

  function bindHighlights(section) {
    bindHighlightsScroll(section);
    bindHighlightsCarousel(section);
  }

  function getTextTransitionMotion() {
    const isMobile = window.matchMedia(MOBILE_MQ).matches;
    return isMobile ? { hookLift: -32 } : { hookLift: -52 };
  }

  function markTextGradientNoScroll(section) {
    section.dataset.nnpTextGradientInited = '1';
    section.dataset.nnpTextGradientNoScroll = '1';
  }

  /** 文案过渡 — 滚动 */
  function setupTextGradientScroll(section, gsap, ScrollTrigger, ctx) {
    const {
      hookEl,
      revealEl,
      headlineEl,
      subtitleEl,
      revealLines,
      TIMING,
      hasHook,
      headlineStart,
      subtitleStart,
      revealPhaseStart,
      syncRevealA11y
    } = ctx;

    if (headlineEl instanceof HTMLElement) {
      gsap.set(headlineEl, { opacity: 0 });
    }
    if (subtitleEl instanceof HTMLElement) {
      gsap.set(subtitleEl, { opacity: 0 });
    }
    syncRevealA11y(false);

    if (hasHook) {
      gsap.set(hookEl, { y: 0, opacity: 1, visibility: 'visible' });
    }

    // ScrollTrigger: center center → top top
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: 'center center',
        end: 'top top',
        scrub: 0.45,
        invalidateOnRefresh: true,
        fastScrollEnd: true,
        onUpdate: (self) => {
          const revealStartRatio = revealPhaseStart / Math.max(tl.duration(), 0.0001);
          syncRevealA11y(self.progress >= revealStartRatio);
          section.classList.toggle('is-revealed', self.progress >= 0.999);
        }
      },
      defaults: { ease: 'none' }
    });

    if (hasHook) {
      tl.to(
        hookEl,
        {
          y: () => getTextTransitionMotion().hookLift,
          autoAlpha: 0,
          duration: TIMING.hook
        },
        0
      );
    }

    if (headlineEl instanceof HTMLElement) {
      tl.to(headlineEl, { opacity: 1, duration: TIMING.headline }, headlineStart);
    }

    if (subtitleEl instanceof HTMLElement) {
      tl.to(subtitleEl, { opacity: 1, duration: TIMING.subtitle }, subtitleStart);
    }

    const scrollTrigger = tl.scrollTrigger;
    section._nnpTextGradientScrollTrigger = scrollTrigger;

    let lastIsMobile = window.matchMedia(MOBILE_MQ).matches;
    let resizeTimer = 0;
    let rebuilding = false;

    const tearDownTimeline = () => {
      window.removeEventListener('resize', debouncedResize);
      window.clearTimeout(resizeTimer);
      if (scrollTrigger) scrollTrigger.kill();
      tl.kill();
      if (hookEl instanceof HTMLElement) {
        gsap.set(hookEl, { clearProps: 'opacity,visibility,transform' });
      }
      gsap.set(revealLines, { clearProps: 'opacity' });
      section.classList.remove('is-revealed');
      delete section._nnpTextGradientScrollTrigger;
    };

    const rebuildForBreakpoint = () => {
      if (rebuilding) return;
      rebuilding = true;
      tearDownTimeline();
      setupTextGradientScroll(section, gsap, ScrollTrigger, ctx);
      ScrollTrigger.refresh();
    };

    const onResize = () => {
      const nextIsMobile = window.matchMedia(MOBILE_MQ).matches;
      if (nextIsMobile !== lastIsMobile) {
        lastIsMobile = nextIsMobile;
        rebuildForBreakpoint();
        return;
      }
      ScrollTrigger.refresh();
    };

    const debouncedResize = () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(onResize, 150);
    };
    window.addEventListener('resize', debouncedResize);
    window.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
    window.requestAnimationFrame(() => ScrollTrigger.refresh());

    section._nnpTextGradientCleanup = () => {
      tearDownTimeline();
      delete section.dataset.nnpTextGradientInited;
      delete section.dataset.nnpTextGradientNoScroll;
    };
  }

  function bindTextGradientScroll(section) {
    if (!(section instanceof HTMLElement)) return;
    if (section.dataset.nnpTextGradientInited === '1') return;

    const hookEl = section.querySelector('.ug-new-nexode-pro__text-transition-hook');
    const revealEl = section.querySelector('.ug-new-nexode-pro__text-transition-reveal');
    if (!(revealEl instanceof HTMLElement)) {
      markTextGradientNoScroll(section);
      return;
    }

    const headlineEl = revealEl.querySelector('.ug-new-nexode-pro__text-transition-headline');
    const subtitleEl = revealEl.querySelector('.ug-new-nexode-pro__text-transition-subtitle');

    const revealLines = [headlineEl, subtitleEl].filter((el) => el instanceof HTMLElement);

    // TIMING: hook / afterHook / headline / afterHeadline / subtitle
    const TIMING = {
      hook: 0.56,
      afterHook: 0.08,
      headline: 0.34,
      afterHeadline: 0.1,
      subtitle: 0.32
    };

    const hasHook = hookEl instanceof HTMLElement;
    const headlineStart = hasHook ? TIMING.hook + TIMING.afterHook : 0;
    const subtitleStart = headlineStart + TIMING.headline + TIMING.afterHeadline;
    const revealPhaseStart = headlineStart;

    const syncRevealA11y = (active) => {
      if (active) revealEl.removeAttribute('aria-hidden');
      else revealEl.setAttribute('aria-hidden', 'true');
    };

    const showRevealInstant = () => {
      syncRevealA11y(true);
      revealLines.forEach((line) => {
        line.style.opacity = '1';
      });
    };

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      markTextGradientNoScroll(section);
      section.classList.add('is-revealed');
      if (hookEl instanceof HTMLElement) hookEl.style.display = 'none';
      showRevealInstant();
      return;
    }

    let aborted = false;
    const cancelWait = whenGsapReady(
      (gsap, ScrollTrigger) => {
        if (aborted || !section.isConnected) return;
        if (section.dataset.nnpTextGradientInited === '1') return;
        section.dataset.nnpTextGradientInited = '1';

        setupTextGradientScroll(section, gsap, ScrollTrigger, {
          hookEl,
          revealEl,
          headlineEl,
          subtitleEl,
          revealLines,
          TIMING,
          hasHook,
          headlineStart,
          subtitleStart,
          revealPhaseStart,
          syncRevealA11y
        });
      },
      () => {
        if (aborted || !section.isConnected) return;
        markTextGradientNoScroll(section);
        section.classList.add('is-revealed');
        if (hookEl instanceof HTMLElement) hookEl.style.display = 'none';
        showRevealInstant();
      }
    );

    section._nnpGsapWaitCancel = () => {
      aborted = true;
      if (typeof cancelWait === 'function') cancelWait();
      delete section._nnpGsapWaitCancel;
    };
  }

  function bindProductsPreOrder(root) {
    const clearBuyLoading = (buyBtn) => {
      if (!(buyBtn instanceof HTMLElement)) return;
      buyBtn.classList.remove('loading');
      if (buyBtn instanceof HTMLButtonElement && !buyBtn.classList.contains('is-disabled')) {
        buyBtn.disabled = false;
      }
      const prev = buyBtn.style.transform;
      buyBtn.style.transform = 'translateZ(0)';
      void buyBtn.offsetWidth;
      requestAnimationFrame(() => {
        buyBtn.style.transform = prev;
      });
    };

    const clearAllBuyLoading = () => {
      root
        .querySelectorAll('.ug-nexode-air-template__charge-promo-buy, [data-na-charge-promo-buy]')
        .forEach(clearBuyLoading);
    };

    const onDialogClose = () => clearAllBuyLoading();
    const onCartUpdate = (e) => {
      if (e && e.detail && e.detail.data && e.detail.data.didError) return;
      clearAllBuyLoading();
    };
    // DialogCloseEvent 默认不冒泡，须 capture 才能在 document 收到
    document.addEventListener('dialog:close', onDialogClose, true);
    document.addEventListener('cart:update', onCartUpdate, true);

    const onClick = async (e) => {
      const buyBtn = e.target.closest('[data-na-charge-promo-buy]');
      if (!(buyBtn instanceof HTMLButtonElement)) return;
      if (!(root instanceof HTMLElement) || !root.contains(buyBtn)) return;

      e.preventDefault();
      e.stopPropagation();

      if (buyBtn.disabled || buyBtn.classList.contains('is-disabled')) return;
      if (buyBtn.classList.contains('loading')) return;

      const zone = buyBtn.closest('[data-nnp-product-cta], [data-na-editions-cta]');
      if (!(zone instanceof HTMLElement)) return;

      const url =
        zone.getAttribute('data-charge-promo-product-url')?.trim() ||
        zone.getAttribute('data-ug-quick-add-url')?.trim() ||
        '';
      const title = zone.getAttribute('data-charge-promo-product-title') || '';
      if (!url) return;

      buyBtn.classList.add('loading');
      buyBtn.disabled = true;
      try {
        const opened = await nnpOpenQuickAdd(url, title);
        if (!opened) clearBuyLoading(buyBtn);
      } catch (_) {
        clearBuyLoading(buyBtn);
      }
    };

    root.addEventListener('click', onClick, true);
    return () => {
      root.removeEventListener('click', onClick, true);
      document.removeEventListener('dialog:close', onDialogClose, true);
      document.removeEventListener('cart:update', onCartUpdate, true);
    };
  }

  /** 产品 Quick Add；成功打开弹窗返回 true */
  async function nnpOpenQuickAdd(productPageUrl, productTitle) {
    if (!productPageUrl) return false;

    const getOpen = () =>
      window.UGREEN && window.UGREEN.quickAdd && window.UGREEN.quickAdd.open;

    let open = getOpen();
    // 仅「API 未注入」时短等；open 已处理失败/跳转并返回 false 时不再重试
    if (typeof open !== 'function') {
      await new Promise((resolve) => window.setTimeout(resolve, 120));
      open = getOpen();
    }

    if (typeof open === 'function') {
      return (await open(productPageUrl, { title: productTitle || '' })) === true;
    }

    window.location.href = productPageUrl;
    return false;
  }

  function bindProductsCarousel(productsRoot) {
    if (!(productsRoot instanceof HTMLElement)) return () => {};

    const cardsWrap = productsRoot.querySelector('[data-nnp-products-cards]');
    if (!(cardsWrap instanceof HTMLElement)) return () => {};

    if (cardsWrap.dataset.nnpProductsCarouselInited === '1') {
      return cardsWrap._nnpProductsCarouselCleanup || (() => {});
    }

    const track = cardsWrap.querySelector('[data-nnp-products-track]');
    const cards = track ? Array.from(track.querySelectorAll('.ug-new-nexode-pro__product-card')) : [];
    if (!track || cards.length < 2) {
      return () => {};
    }

    cardsWrap.dataset.nnpProductsCarouselInited = '1';
    let index = 0;
    const cleanups = [];
    const prevBtn = cardsWrap.querySelector('[data-nnp-products-prev]');
    const nextBtn = cardsWrap.querySelector('[data-nnp-products-next]');
    const progress = cardsWrap.querySelector('[data-nnp-products-progress]');
    const progressFill = cardsWrap.querySelector('[data-nnp-products-progress-fill]');
    const mobileMq = window.matchMedia(MOBILE_MQ);

    const isMobile = () => mobileMq.matches;

    const updateControls = (nextIndex) => {
      if (progress instanceof HTMLElement) {
        progress.setAttribute('aria-valuenow', String(nextIndex + 1));
      }
      if (progressFill instanceof HTMLElement) {
        progressFill.style.width = ((nextIndex + 1) / cards.length) * 100 + '%';
      }
      if (prevBtn instanceof HTMLButtonElement) {
        prevBtn.disabled = nextIndex <= 0;
      }
      if (nextBtn instanceof HTMLButtonElement) {
        nextBtn.disabled = nextIndex >= cards.length - 1;
      }
    };

    const goToIndex = (nextIndex, smooth) => {
      if (!isMobile()) {
        track.style.transform = '';
        track.style.transition = '';
        return;
      }
      index = Math.max(0, Math.min(cards.length - 1, nextIndex));
      const card = cards[index];
      const offset =
        card instanceof HTMLElement ? Math.max(0, card.offsetLeft - track.clientLeft) : 0;
      track.style.transition = smooth ? 'transform 0.3s ease' : 'none';
      track.style.transform = offset > 0 ? `translateX(-${offset}px)` : '';
      updateControls(index);
    };

    if (prevBtn instanceof HTMLButtonElement) {
      const handler = (event) => {
        event.preventDefault();
        goToIndex(index - 1, true);
      };
      prevBtn.addEventListener('click', handler);
      cleanups.push(() => prevBtn.removeEventListener('click', handler));
    }
    if (nextBtn instanceof HTMLButtonElement) {
      const handler = (event) => {
        event.preventDefault();
        goToIndex(index + 1, true);
      };
      nextBtn.addEventListener('click', handler);
      cleanups.push(() => nextBtn.removeEventListener('click', handler));
    }

    const onMqChange = () => {
      goToIndex(isMobile() ? index : 0, false);
    };
    mobileMq.addEventListener('change', onMqChange);
    cleanups.push(() => mobileMq.removeEventListener('change', onMqChange));

    goToIndex(0, false);

    cardsWrap._nnpProductsCarouselCleanup = () => {
      track.style.transform = '';
      track.style.transition = '';
      cleanups.forEach((fn) => fn());
      delete cardsWrap._nnpProductsCarouselCleanup;
      delete cardsWrap.dataset.nnpProductsCarouselInited;
    };
    return cardsWrap._nnpProductsCarouselCleanup;
  }

  function bindProducts(root) {
    const cleanups = [bindProductsPreOrder(root)];
    root.querySelectorAll('[data-nnp-products]').forEach((section) => {
      cleanups.push(bindProductsCarousel(section));
    });
    return () => cleanups.forEach((fn) => {
      if (fn) fn();
    });
  }

  function initSection(root) {
    root.querySelectorAll('[data-nnp-email]').forEach(bindEmailBlock);
    root.querySelectorAll('.ug-new-nexode-pro__terms').forEach(bindTermsModal);
    root.querySelectorAll('[data-nnp-text-reveal]').forEach(bindTextGradientScroll);
    root.querySelectorAll('[data-nnp-highlights]').forEach(bindHighlights);
    root._nnpProductsCleanup = bindProducts(root);
  }

  if (customElements.get(TAG_NAME)) {
    return;
  }

  class NewNexodeProSection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.nnpInited === '1') return;
      this.dataset.nnpInited = '1';
      initSection(this);
    }

    disconnectedCallback() {
      delete this.dataset.nnpInited;
      this.querySelectorAll('[data-nnp-email]').forEach((block) => {
        if (block._nnpEmailCleanup) {
          try {
            block._nnpEmailCleanup();
          } catch (_) {}
        } else {
          delete block.dataset.nnpEmailInited;
        }
      });
      this.querySelectorAll('.ug-new-nexode-pro__terms').forEach((section) => {
        if (section._nnpTermsCleanup) {
          try {
            section._nnpTermsCleanup();
          } catch (_) {}
          delete section._nnpTermsCleanup;
        } else {
          delete section.dataset.nnpTermsInited;
        }
      });
      this.querySelectorAll('[data-nnp-text-reveal]').forEach((section) => {
        if (section._nnpGsapWaitCancel) {
          try {
            section._nnpGsapWaitCancel();
          } catch (_) {}
        }
        if (section._nnpTextGradientCleanup) {
          try {
            section._nnpTextGradientCleanup();
          } catch (_) {}
          delete section._nnpTextGradientCleanup;
        }
      });
      this.querySelectorAll('[data-nnp-highlights]').forEach((section) => {
        if (section._nnpGsapWaitCancel) {
          try {
            section._nnpGsapWaitCancel();
          } catch (_) {}
        }
        if (section._nnpHighlightsScrollCleanup) {
          try {
            section._nnpHighlightsScrollCleanup();
          } catch (_) {}
          delete section._nnpHighlightsScrollCleanup;
        }
        if (section._nnpHighlightsCarouselCleanup) {
          try {
            section._nnpHighlightsCarouselCleanup();
          } catch (_) {}
        }
      });
      if (this._nnpProductsCleanup) {
        try {
          this._nnpProductsCleanup();
        } catch (_) {}
        delete this._nnpProductsCleanup;
      }
    }
  }

  customElements.define(TAG_NAME, NewNexodeProSection);
})();
